import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import {
  ThemeProvider,
  CssBaseline,
  CircularProgress,
  Box,
} from "@mui/material";
import Intro from "./Pages/Intro";
import Login from "./Pages/Login";
import Register from "./Pages/Register";
import ForgotPassword from "./Pages/ForgotPassword";
import ChangePassword from "./Pages/ChangePassword";
import Profile from "./Pages/Profile";
import Admin from "./Pages/Admin";
import Dashboard from "./Pages/Dashboard";
import StoryPage from "./Pages/StoryPage";
import CreateStory from "./Pages/CreateStory";
import { AuthProvider, useAuth } from "./Utility/AuthContext";
import Layout from "./Components/Layout";
import Seo from "./Components/Seo";
import theme from "./theme";
import "./App.css";

function Protected({ children, admin = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading)
    return (
      <Box sx={{ p: 8, textAlign: "center" }}>
        <CircularProgress aria-label="Loading account" />
      </Box>
    );
  if (!user)
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (admin && !user.isAdmin) return <Navigate to="/dashboard" replace />;
  return children;
}
function PrivatePage({ title, children }) {
  return (
    <>
      <Seo title={title} noindex />
      {children}
    </>
  );
}
function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element={<Intro />} />
              <Route path="/intro" element={<Navigate to="/" replace />} />
              <Route
                path="/login"
                element={
                  <PrivatePage title="Sign in">
                    <Login />
                  </PrivatePage>
                }
              />
              <Route
                path="/register"
                element={
                  <PrivatePage title="Create an account">
                    <Register />
                  </PrivatePage>
                }
              />
              <Route
                path="/forgotpassword"
                element={
                  <PrivatePage title="Recover your account">
                    <ForgotPassword />
                  </PrivatePage>
                }
              />
              <Route
                path="/changepassword"
                element={
                  <Protected>
                    <PrivatePage title="Change password">
                      <ChangePassword />
                    </PrivatePage>
                  </Protected>
                }
              />
              <Route
                path="/admin"
                element={
                  <Protected admin>
                    <PrivatePage title="Review stories">
                      <Admin />
                    </PrivatePage>
                  </Protected>
                }
              />
              <Route path="/profile/:username" element={<Profile />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/story/:id" element={<StoryPage />} />
              <Route
                path="/create"
                element={
                  <Protected>
                    <CreateStory />
                  </Protected>
                }
              />
              <Route
                path="/edit/:id"
                element={
                  <Protected>
                    <CreateStory />
                  </Protected>
                }
              />
              <Route
                path="*"
                element={
                  <PrivatePage title="Page not found">
                    <div className="empty-state">
                      <h1>That path is unwritten.</h1>
                      <a href="/">Return to the beginning</a>
                    </div>
                  </PrivatePage>
                }
              />
            </Routes>
          </Layout>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}
export default App;
